import * as React from "react"

import { StaticImage } from 'gatsby-plugin-image';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faSteam
} from '@fortawesome/free-brands-svg-icons'

// Styles
import "../../styles/homepage/homepage_section-steam.scss"

// markup
const SteamSection = () => {
    return (
        <div className="homepage_section-dark homepage_section_steam">

            <div className="wrapper-narrow">

                <h1>
                    Wishlist Now
                </h1>

                <h2>
                    Super Snow Tubes is coming to Steam
                </h2>

                <a
                    href="https://store.steampowered.com/app/1515590/Super_Snow_Tubes/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <StaticImage
                        alt="Steam logo"
                        src="../../images/homepage/steam-logo.png"
                    />
                </a>

                <p>
                    Wishlist the game now to get notified on launch day, including a sweet <strong>launch discount</strong>.
                </p>

                <a
                    className="button"
                    href="https://store.steampowered.com/app/1515590/Super_Snow_Tubes/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <FontAwesomeIcon icon={faSteam} className="icon" />
                    Add to your Wishlist
                </a>

                <p className="small">
                    PS: Wishlisting your favourite games on Steam, especially before they are released, helps them get the exposure they deserve, have a succesful launch, and impact as many players as possible. It’s free for you, but it means the world to indie game developers! {/*Pwetty pleash?*/}
                </p>

            </div>

        </div >
    )
}

export default SteamSection